import React from 'react'
import "../../../App.css"
export default function LandingSection() {
  return (
    <section class="text-gray-400 h-screen">
        
  <div class="container mx-auto flex px-5 py-48 items-center justify-center flex-col">
    <div class="text-center lg:w-2/3 w-full">
      <h1 class=" sm:text-8xl text-7xl font-medium mr-24  font-YellowTail text-white">The</h1>
      <h1 class=" sm:text-9xl text-8xl mb-4 font-medium font-YellowTail text-white">Silence</h1>
      <div class="flex justify-center">
      </div>
    </div>
  </div>

</section>
  )
}
